var _rect, _title, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ionicons-v5-c") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.4186046719551,432.5813953280449 H159.4186046719551 a16,16 0 0 1 -16,-16 V96.58139532804489 a16,16 0 0 1 16,-16 h48 a16,16 0 0 1 16,16 V416.5813953280449 A16,16 0 0 1 207.4186046719551,432.5813953280449 z",
    id: "svg_1",
    className: "",
    fill: "#ffffff",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.4186046719551,431.9966000318527 H159.4186046719551 a16,16 0 0 1 -16,-16 V95.99660003185272 a16,16 0 0 1 16,-16 h48 a16,16 0 0 1 16,16 V415.9966000318527 A16,16 0 0 1 207.4186046719551,431.9966000318527 z",
    className: "",
    fill: "#021f1e",
    fillOpacity: 1,
    id: "svg_3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M352,432H304a16,16,0,0,1-16-16V96a16,16,0,0,1,16-16h48a16,16,0,0,1,16,16V416A16,16,0,0,1,352,432Z",
    id: "svg_2",
    className: "",
    fill: "#021f1e",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPause);
export default __webpack_public_path__ + "static/media/black-pause.cf3900c9993419a2dcc52ebb1268f1e5.svg";
export { ForwardRef as ReactComponent };